<template>
  <div class="god_page_container">
    <h2>Detalle de usuario</h2>    
    <div id="selector_container" style="justify-content: flex-start;">
      <img :src="imageUrl || defaultAvatar" class="avatar" @click="openImageModal"/>
      <input ref="imagePicker" type="file" @change="onFileChange" accept="image/*" style="display: none;" />

      <div style="display: flex; flex-direction: column">
      <label class="checkbox-label">
        <input type="checkbox" name="aceptar" v-model="isActivo" style="width: auto !important;">
        Activo
      </label>
      </div>
    </div>
    <div id="selector_container">

      <select 
        v-model="userType"
        class="input_200">
        <option value="usuario">Particular</option>
        <option value="empresa">Empresa</option>
      </select>

      <input
        type="text"
        class="input_200"
        v-model="userName"
        placeholder="Nombre"
      />

      <input
        type="text"
        class="input_200"
        v-model="userEmail"
        placeholder="Email"
      />

      <input
        type="password"
        class="input_200"
        v-model="password"
        placeholder="Contraseña"
      />

      <input
        type="text"
        class="input_200"
        v-model="userPhone"
        placeholder="Teléfono"
      />

      <input
        v-if="userType == 'usuario'"
        type="date"
        v-model="birthDate"
        class="input_200"/>

      <input
        v-if="userType == 'empresa'"
        type="number"
        v-model="cashbackPercentage"
        placeholder="Porcentaje de cashback"
        class="input_200"/>

    </div>
    
    <div v-if="userType == 'empresa'" class="selector_container" style="margin-top: 20px;">
      <div class="input-100">
        <label>Descripción de la empresa <span @click="toggleHtmlMode" style="cursor: pointer; color: var(--primary-color); font-size: 12px;">(Pincha para ver el HTML)</span></label>
        <QuillEditor 
          v-if="!isHtmlMode"
          theme="snow"
          v-model:content="description"
          contentType="html"
          :toolbar="toolbarOptions"
          style="height: 300px"
          class="cp-quill-editor" />
        <textarea
          v-if="isHtmlMode"
          v-model="description"
          style="height: 300px"
        ></textarea>

      </div>
    </div>

    <div v-if="userType == 'empresa'" class="selector_container" style="margin-top: 20px;">
      <div class="input-100">
        <label>Texto inferior en la web de la empresa <span @click="toggleBottomHtmlMode" style="cursor: pointer; color: var(--primary-color); font-size: 12px;">(Pincha para ver el HTML)</span></label>
        <QuillEditor 
          v-if="!isBottomHtmlMode"
          theme="snow"
          v-model:content="bottomDescription"
          contentType="html"
          :toolbar="toolbarOptions"
          style="height: 300px"
          class="cp-quill-editor" />
        <textarea
          v-if="isBottomHtmlMode"
          v-model="bottomDescription"
          style="height: 300px"
        ></textarea>

      </div>
    </div>

    <br v-if="userType == 'empresa'"/>
    <br v-if="userType == 'empresa'"/>
    <div class="selector_container" v-if="userType == 'empresa'">
      <div class="input-100">
        <label>Política de privacidad de la empresa</label>
        <a v-if="privacidad_url && privacidad_url.startsWith('http')" :href="privacidad_url" target="_blank">Ver PDF subido</a>
        <a v-if="privacidad_url && privacidad_url.startsWith('http')" @click="deletePrivacyPolicy()" style="margin-left: 10px; color: var(--text-color-red) !important; cursor: pointer !important;">Eliminar PDF</a>
        <input
          v-if="!privacidad_url || !privacidad_url.startsWith('http')"
                type="file"
                @change="handlePrivacyFileUpload"
                accept=".pdf" />
      </div>
    </div>
    <br v-if="userType == 'empresa'"/>
    <br v-if="userType == 'empresa'"/>
    <h4 v-if="userType == 'empresa'">Datos de facturación</h4>
    <div v-if="userType == 'empresa'" id="selector_container">
      <input
        type="text"
        class="input_200"
        v-model="invoiceName"
        placeholder="Nombre o razón social"
      />

      <input
        type="text"
        class="input_200"
        v-model="invoiceCif"
        placeholder="CIF"
      />

      <input
        type="text"
        class="input_200"
        v-model="invoiceAddress"
        placeholder="Address"
      />

      <input
        type="text"
        class="input_200"
        v-model="invoiceCity"
        placeholder="Ciudad"
      />

    </div>

    <h4 v-if="userType == 'empresa'">Datos de SEO</h4>
    <div v-if="userType == 'empresa'" id="selector_container">
      <input
        type="text"
        class="input-100"
        v-model="company_seo_title"
        placeholder="Título SEO"
      />

      <input
        type="text"
        class="input-100"
        v-model="company_seo_description"
        placeholder="Descripción SEO"
      />

      <label class="checkbox-label padding-vertical-0" style="margin-top: 0px;">
        <input type="checkbox" name="aceptar" v-model="company_seo_index" style="width: auto !important;">
        Index
      </label>

    </div>

    <br/>
    <br/>

    <div id="selector_container">
      <button @click="saveUserData()" class="input_200 main_button">Guardar</button>
    </div>

    <ErrorPopup :errorMessage="error" />

    <!-- Image Modal -->
    <div
      v-if="showImageModal"
      class="modal-overlay"
      @click.self="closeImageModal"
    >
      <img :src="imageUrl || defaultAvatar" alt="Imagen ampliada" class="modal-content-img"/>
      <button class="main_button modal-content-button" @click="imagePicker.click(); closeImageModal();">Editar</button>
    </div>
  </div>

</template>

<script setup>

  import { ref, nextTick } from 'vue'
  import ErrorPopup from "@/components/common/ErrorPopup.vue";
  import { useLoadingStore } from "@/stores/loadingStore";
  import { useRouter } from 'vue-router';
  import { refreshToken } from "@/services/authService";
  import defaultAvatar from '@/assets/images/ic_profile.png';
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'

  const loadingStore = useLoadingStore();
  const router = useRouter();
  const error = ref(null);
  const imagePicker = ref(null)

  const userType = ref("usuario");
  const userName = ref("");
  const userEmail = ref("");
  const password = ref("");
  const userPhone = ref("");
  const birthDate = ref(null);
  const isActivo = ref(true);
  const imageUrlChanged = ref(false);
  const imageUrl = ref(null);
  const invoiceName = ref("");
  const invoiceCif = ref("");
  const invoiceAddress = ref("");
  const invoiceCity = ref("");
  const privacidad_url = ref("");
  const cashbackPercentage = ref("");
  const description = ref("");
  const bottomDescription = ref("");
  const company_seo_title = ref("");
  const company_seo_description = ref("");
  const company_seo_index = ref(false);

  const showError = async (message) => {
    error.value = null;
    await nextTick();
    error.value = message;
  };

  const saveUserData = async () => {
    if (userName.value === "") {
      showError("Introduce el nombre del usuario");
      return;
    }
    
    if (password.value.trim().length < 6) {
      showError("La contraseña no es válida");
      return
    }

    if (userEmail.value === "" || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail.value)) {
      showError("Introduce un email válido");
      return;
    }

    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await saveUserInfoInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await saveUserInfoInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error creando el usuario.");
        loadingStore.setLoading(false);
        return;
      }

      const data = await response.json();

      if (data.errors) {
        showError(data.message);
        loadingStore.setLoading(false);
      } else {
        error.value = null;
        loadingStore.setLoading(false);
        history.back();
    }      
    } catch (exception) {
      showError(exception.message);
    }
  }

  async function saveUserInfoInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/users/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "type": userType.value,
        "name": userName.value,
        "email": userEmail.value,
        "password": password.value,
        "phone": userPhone.value,
        "birth_date": (userType.value == 'usuario' && birthDate.value != null) ? formatearParaAPI(birthDate.value) : null,
        "cashback_percentage": is_empty(cashbackPercentage.value) ? "0" : cashbackPercentage.value,
        "invoice_name": invoiceName.value,
        "address": invoiceAddress.value,
        "cif": invoiceCif.value,
        "invoice_city": invoiceCity.value,
        "visibility": isActivo.value,
        "picture": imageUrlChanged.value ? imageUrl.value : null,
        "privacidad_url": privacidad_url.value,
        "description": description.value,
        "bottom_description": bottomDescription.value,
        "company_seo_title": company_seo_title.value,
        "company_seo_description": company_seo_description.value,
        "company_seo_index": company_seo_index.value
      }),
    });
  
  }

  function formatearParaAPI(dateStr) {
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  }

  const showImageModal = ref(false);

  function openImageModal() {
    showImageModal.value = true;
  }

  function closeImageModal() {
    showImageModal.value = false;
  }

  function onFileChange(event) {
    const file = event.target.files[0]
    if (!file || !file.type.startsWith('image/')) {
      alert("Selecciona un archivo de imagen válido")
      return
    }

    if (file.size <= 1024 * 1024) {
      const reader = new FileReader()
      reader.onload = e => (imageUrl.value = e.target.result)
      reader.readAsDataURL(file)
      imageUrlChanged.value = true;
      return
    }

    const reader = new FileReader()
    reader.onload = e => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const MAX_WIDTH = 1024
        const MAX_HEIGHT = 1024
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(
          blob => {
            if (blob.size > 1024 * 1024) {
              alert("No se pudo comprimir la imagen por debajo de 1MB")
              return
            }
            const blobReader = new FileReader()
            blobReader.onload = e2 => {
              imageUrl.value = e2.target.result
            }
            blobReader.readAsDataURL(blob)
          },
          'image/jpeg',
          0.8 // calidad 80%
        )
        imageUrlChanged.value = true;
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }

  function handlePrivacyFileUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      const base64Content = e.target.result;
      privacidad_url.value = base64Content;
    };

    reader.readAsDataURL(file);
  }

  function deletePrivacyPolicy() {
    if (confirm("¿Estás seguro de que quieres eliminar el PDF de la política de privacidad?")) {
      privacidad_url.value = "";
    }
  }

  const is_empty = (value) => {
    return value === null || value === undefined || String(value).trim() === '';
  };


  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike','link'],
    [{ header: [1, 2, 3, false] }],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean']
  ];

  const isHtmlMode = ref(false)

  const toggleHtmlMode = () => {
    isHtmlMode.value = !isHtmlMode.value
  }

  const isBottomHtmlMode = ref(false)

  const toggleBottomHtmlMode = () => {
    isBottomHtmlMode.value = !isBottomHtmlMode.value
  }

</script>

<style scoped>

#selector_container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 1rem;
  justify-content: space-between;
  align-items: center;
}

.input_200 {
  box-sizing: border-box;
  min-width: 200px;
  flex: 1 1 200px;
  padding: 8px;
  width: 100%;
  line-height: 1.2;
  height: 50px;
  max-height: 50px;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 30px;
  min-width: 800px;
}

th {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: var(--gray);
  color: white;
  border: 0px;
}

tfoot {
  background-color: var(--gray);
  color: white;
  border: 0px;
}
.big {
  width: 20%;
}

.small {
  width: 10%;
}

tr{
  cursor: pointer;
}

td {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
}

.bg-gray-100 {
  background-color: var(--almost-white);
}

.bg-white {
  background-color: white;
}

.avatar {
  width: 150px;
  height: 150px;
  cursor: pointer;
  object-fit: cover;
  border-radius: 50%;
}

/* Fondo translúcido */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content-img {
  width: min(50vw, 500px);
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 50%;
}

.modal-content-button {
  width: min(50vw, 500px);
  margin-top: 30px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 1 auto;
  padding: 8px;
  height: auto;
  cursor: pointer;
  width: auto;
}

.padding-vertical-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.checkbox-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin: 0;
}

@media (max-width: 768px) {
  #selector_container > * {
    flex: none !important;
    justify-content: center;
  }

  .input_200 {
    width: 100%;
  }

  table {
    width: 100%;
    min-width: 0px;
  }

  .avatar {
    width: 150px;
    height: 150px;
    cursor: pointer;
    object-fit: cover;
    border-radius: 50%;
    margin: 0 auto;
  }

  .modal-content-img {
    width: min(90vw, 300px);
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 50%;
  }

  .modal-content-button {
    width: min(90vw, 300px);
  }

}

/* Quill Editor Overrides */
::v-deep(.ql-container) {
  font-family: "GatterSans" !important;
  font-size: 16px !important;
  border-bottom-left-radius: var(--radius-md);
  border-bottom-right-radius: var(--radius-md);
  background-color: var(--white);
}

::v-deep(.ql-toolbar) {
  border: 1px solid var(--light-gray) !important;
  border-top-left-radius: var(--radius-md);
  border-top-right-radius: var(--radius-md);
  background-color: var(--white);
}

::v-deep(.ql-editor) {
  border: 1px solid var(--light-gray) !important;
  border-top: 0px;
  min-height: 200px;
}

</style>
